import {createRequest} from 'utils/request';
const url = '/openapi';
function request(type,url,params){
    return createRequest(type,url,params,true,false,true).then(res=>{
        res.accountType = 'new';
        return res;
    }).catch(res=>{
        const data = {
            code:res.data.errcode || 4,
            msg:res.data.errmsg || 'Error'
        };
        const error = {
            code:4,
            msg: 'Error'
        };
        return Promise.reject({data,error});
    });
}

export function checkLogin() {
    return request('GET', url+'/user/profile',null,true,true);
}

export function login(username, password, captcha) {
    // return request('POST', url+'/login', { username, password, captcha },true);
    return Promise.resolve({accountType:'new'});
}

export function checkUserName(username) {
    return request('GET', url+'/check_username',{username});
}

export function register(params) {
    return request('POST', url+'/register', params, true);
}
export function emailToken(email,type='register_token') {
    return request('GET', url+'/email_token', { email,type });
}

export function forgetPassword(username,email) {

    return request('POST', url+'/forget_password', { username,email }, true);
}

export function resetPassword(params) {
    return request('POST', url+'/reset_password', params, true);
}

export function captcha(type, value) {
    return function (dispatch) {
        return request('GET', url+'/captcha', { type, value });
    };
}



// WEBPACK FOOTER //
// ./src/actions/account.js